import { api } from "../api";

export const updateTherapistAvailable= async (therapistId, data) => {
  try {
    const response = await api.put(`/therapists/${therapistId}/preference`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getTherapist = async (userId) => {
  try {
    const response = await api.get(`/therapists/${userId}/preference`);
    return response.data;
  } catch (error) {
    throw error;
  }
};